module.exports = {
  TheExpiredAndNoCreated: '该委托单位合同到期，不能再创建业务！',
  NotTheCorrectOperationStatus: '不是正操作状态.',
  NoDataSelected: '未选择数据',
  AllAreInNonStatus: '选择的数据记录全部为非【正操作】状态',
  ThisSelfConsolidationBuyerConsolidation: '该票业务整拼类型不是自拼箱、buyer consol、委托拼箱',
  AttachmentContentTooLarge: '附件内容过大',
  AreWantToWithdrawBill: '确定要撤回该票业务吗?',
  SplitOrder: '拆单',
  MergeOrder: '并单',
  SRIFailedPleaseContactTroubleshooting: '思锐委托单推送失败,请联系工作人员排查:',
  OperationSuccessful: '操作成功',
  ContainerType: '箱种',
  LockedPrintedPleaseContactUnlocking: '已被锁定,不能打印,请联系上级主管解锁!',
  FullContainerProfitPrint: '整箱利润打印',
  LCLProfitPrint: '拼箱利润打印',
  NoSubTicketSelected: '未选择小票',
  CustomersSuchAsPOEtc: '指客户方对托运货运的自有编号，如PO NBR, ITEM NBR 等。',
  OriginalBillOfLading: '正本',
  TelexRelease: '电放',
  NoLoadingInformationSelected: '未勾选装箱信息',
  PleaseASubTicketRecord: '请选择小票记录',
  PleaseSelectAContainer: '请选中一个箱子',
  BillOfLadingInformationTracking: '提单信息追踪',
  ReleaseNumber: '放单号:',
  Unknown: '不详',
  ViewExceptions: '查看异常',
  PleaseSelectDesignatedData: '请选择指定数据',
  LicenseOfLadingNumberEmpty: '车牌号和提单号不能为空',
  NoRelevantInformationAvailable: '暂无相关信息',
  DoToDeleteTheTicket: '是否要删除小票?',
  AuditSuccessful: '审核成功',
  Allocation: '分拨',
  ChangeOrders: '换单',
  ImportManifest: '进口舱单'
}
